module.exports = __webpack_public_path__ + "assets/img/tag-new-server-d336939b.png";